import React, { useState, useEffect } from 'react';
import EcommerceWebsite from './components/EcommerceWebsite';
import StandaloneAdminDashboard from './components/admin/StandaloneAdminDashboard';
import AdminResetPassword from './components/admin/AdminResetPassword';

const resolveView = (hash) => {
  if (hash.startsWith('#admin-reset-password')) return 'admin-reset-password';
  if (hash === '#admin-dashboard') return 'admin';
  return 'main';
};

function App() {
  const [currentView, setCurrentView] = useState(() => resolveView(window.location.hash));

  useEffect(() => {
    const handleHashChange = () => setCurrentView(resolveView(window.location.hash));
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  if (currentView === 'admin-reset-password') {
    return <AdminResetPassword />;
  }

  if (currentView === 'admin') {
    return <StandaloneAdminDashboard />;
  }

  // Default to main ecommerce website
  return <EcommerceWebsite />;
}

export default App;